import React, {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import ApexChart from "../components/ApexCharts";

const Case = () => {
  const [data, setData] = useState(null);

  const {name} = useParams();

  useEffect(() => {
    fetch('/data/profitability.json')
      .then(response => response.json())
      .then(data => setData(data))
      .catch(error => console.error(error));
  }, [])


  if (!data) {
    return <div style={styles.loading}>Loading...</div>;
  }

  const item = data && data.profitability.find(item => item.name.replaceAll(' ', '-').toLowerCase() === name);

  if (!item) {
    return <div style={styles.error}>Not found...</div>;
  }

  return (
    <div style={styles.container}>
      <div style={styles.title}>{item.name}</div>
      <div style={styles.dataContainer}>
        <div style={styles.data}>
          <div style={styles.label}>Cost:</div>
          <div style={styles.value}>${item.cost.toFixed(2)}</div>
        </div>
        <div style={styles.data}>
          <div style={styles.label}>Total Return:</div>
          <div style={styles.value}>${item.total_return.toFixed(2)}</div>
        </div>
        <div style={styles.data}>
          <div style={styles.label}>Profit:</div>
          <div style={styles.value}>{item.profitability_ratio.toFixed(2)}%</div>
        </div>
      </div>
      <ApexChart caseName={item.name}/>
      <div style={styles.items}>
        <div style={styles.itemHeader}>
          <div style={styles.itemHeaderCell}>Name</div>
          <div style={styles.itemHeaderCell}>Cost</div>
        </div>
        {Object.entries(item.average_prices).map(([itemName, itemPrice]) => (
          <div key={itemName} style={styles.itemRow}>
            <div style={styles.itemCell}>{itemName}</div>
            <div style={styles.itemCell}>${itemPrice.toFixed(2)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // padding: "32px",
    width: '100%',
  },
  loading: {textAlign: 'center'},
  error: {textAlign: 'center'},
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "16px",
  },
  dataContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: "32px",
  },
  data: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    width: "25%",
  },
  label: {
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: "8px",
  },
  value: {
    fontSize: "24px",
    fontWeight: "bold",
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",

  },
  headerRow: {
    backgroundColor: "#EDEDED",
    display: "table-row",
    fontWeight: "bold",
    textAlign: "left",
  },
  headerCell: {
    // border: "1px solid #EDEDED",
    padding: "8px",
  },
  items: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    maxWidth: "1200px",

  },
  itemHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#EDEDED",
    fontWeight: "bold",
    textAlign: "left",
    borderRadius: "4px",
    marginBottom: "8px",
  },
  itemHeaderCell: {
    padding: "8px",
    flexBasis: "50%",
    maxWidth: "50%",
  },
  itemRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #EDEDED",
    padding: "8px 0",
  },
  itemCell: {
    flexBasis: "50%",
    maxWidth: "50%",
  },
};

export default Case;
